import { Sort as EBackendSort } from '../shared/types/apollo';
import type { Sidebar } from '@/pages/search/-src/features/search-filters/models/sidebar';

export interface IAnalyticsEvents {
  sort: EBackendSort;
  selectedFilters: string;
  pageType: Sidebar.EPageType;
}

export interface IQueryMisprint {
  isMisPrinterOn?: boolean;
  originSearchWord?: string;
  correctedSearchText?: string;
}

export const filters = {
  namespaced: true,
  state: {
    isFiltersStateSaved: false,
    isNeedToSearchAgain: false,
    analyticsEvents: {
      sort: EBackendSort.BY_RELEVANCE_DESC,
      selectedFilters: '',
      pageType: null,
    },
    queryMisPrinter: {
      isMisPrinterOn: true,
      originSearchWord: '',
      correctedSearchText: '',
    },
  },
  mutations: {
    setFiltersStateSaved(state: { isFiltersStateSaved: boolean; }, isFiltersStateSaved: boolean): void {
      if (!state) return;
      state.isFiltersStateSaved = isFiltersStateSaved;
    },
    setNeedToSearchAgain(state: { isNeedToSearchAgain: boolean; }, isNeedToSearchAgain: boolean): void {
      if (!state) return;
      state.isNeedToSearchAgain = isNeedToSearchAgain;
    },
    setAnalyticsEvents(state: { analyticsEvents: IAnalyticsEvents; }, analyticsEvents: IAnalyticsEvents): void {
      state.analyticsEvents = analyticsEvents;
    },
    setQueryMisPrinterOn(state: { queryMisPrinter: any; }, queryMisPrinter: IQueryMisprint): void {
      if (!state) return;
      state.queryMisPrinter = { ...state.queryMisPrinter, ...queryMisPrinter };
    },
  },
};
